import { LoadingButton } from "@mui/lab";
import { Button, Paper, Typography } from "@mui/material";
import { myPagesFortnoxVerifyGUID } from "API/myPages";
import { fortnoxVerifyGUID } from "API/swesum";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Verify = ({ fromMyPages = false }) => {
  const { uuid } = useParams();
  const [errText, setErrText] = useState("");
  const [fortnoxUrl, setFortnoxUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const asyncVerifyUUID = async (uuid) => {
    let res = null;
    if (fromMyPages) {
      res = await myPagesFortnoxVerifyGUID(uuid);
    } else {
      res = await fortnoxVerifyGUID(uuid);
    }
    if (res.status === 200) {
      setFortnoxUrl(res.data);
    } else {
      setErrText("Ogiltig länk");
    }
  };

  useEffect(() => {
    if (uuid) {
      asyncVerifyUUID(uuid);
    }
  }, [uuid, asyncVerifyUUID]);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {errText ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            marginTop: "30px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5">{errText}</Typography>
          <Button variant="contained" onClick={() => navigate("/")}>
            Gå till startsida
          </Button>
        </div>
      ) : fortnoxUrl ? (
        <Paper
          sx={{
            height: "300px",
            marginTop: "40px",
            padding: "30px",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "30px",
              maxWidth: "750px",
            }}
          >
            <Typography variant="h3">Välkommen att verifiera dig</Typography>
            <Typography>
              Nu skall du godkänna för Fortnox att Swesum skall ta hand om dina
              fakturor. Vi kommer att omdirigera dig till Fortnox för
              inloggning.
            </Typography>
            <LoadingButton
              variant="contained"
              color="success"
              loading={loading}
              sx={{ maxWidth: "200px" }}
              onClick={() => {
                setLoading(true);
                window.location.href = fortnoxUrl;
              }}
            >
              Till fortnox
            </LoadingButton>
            <Typography>
              När du kommer tillbaka skall allt vara klart
            </Typography>
          </div>
        </Paper>
      ) : null}
    </div>
  );
};

export default Verify;
